var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartIconEmpty = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.686 4.675A5.763 5.763 0 0 1 7.766 3c1.483 0 2.966.559 4.097 1.673l.001.001.136.135.136-.135.001-.001A5.817 5.817 0 0 1 16.224 3c1.492 0 2.967.559 4.09 1.675v.001a5.687 5.687 0 0 1 0 8.083l-.001.001-.632.626L12.01 21l-8.323-8.249a5.677 5.677 0 0 1-.002-8.075zm.997.954a4.337 4.337 0 0 0-.002 6.166l7.328 7.263 6.677-6.627.632-.626a4.356 4.356 0 0 0-3.094-7.442A4.404 4.404 0 0 0 13.13 5.63L12 6.75l-1.128-1.117h-.001a4.41 4.41 0 0 0-3.105-1.27A4.35 4.35 0 0 0 4.683 5.63",
    clipRule: "evenodd"
  })));
};
export default SvgHeartIconEmpty;